import React from 'react';
import { Route } from 'react-router-dom';
import { RequireRole } from './guards';
import ComingSoon from '../pages/admin/ComingSoon';

/**
 * Builds the <Route>s of a panel (admin or organiser) from its section list, so a section is
 * declared once and drives both its URL and its sidebar entry.
 *   soon    the section has no screen yet: shows the "coming soon" page with this message
 *   splat   the section owns everything under its URL and routes it itself (tabs, sub-pages)
 *   roles   only these roles may open it (its menu entry is hidden for others by PanelLayout)
 *   root    the panel's own URL: the section living exactly there becomes the index page
 */
export function sectionRoutes(sections, { root }) {
  const one = (s) => {
    const element = s.soon ? <ComingSoon title={s.label} message={s.soon} /> : <s.Component />;
    if (s.path === root) return <Route key={s.key} index element={element} />;
    return <Route key={s.key} path={s.splat ? `${s.path}/*` : s.path} element={element} />;
  };
  return sections.map((s) => (s.roles ? <Route key={s.key} element={<RequireRole roles={s.roles} />}>{one(s)}</Route> : one(s)));
}
